export const CHECKOUT_FIELD_NAMES = {
  ARE_ADDRESSES_SAME: 'areAddressesSame',
  CONTACT_EMAIL: 'contactEmail',
  SHIPPING_ADDRESS: 'shippingAddress',
  BILLING_ADDRESS: 'billingAddress',
  SHIPPING_METHOD: 'shippingMethod',
  ITEMS_QUANTITY: 'itemsQuantity',
  CARD: 'card',
  PAYMENT_OPTION: 'paymentOption',
  ARE_TERMS_ACCEPTED: 'areTermsAccepted',
  USE_TAX_EXEMPTION: 'useTaxExemption',
} as const
